import { string, struct } from 'io-ts/Decoder';

export const Attachment = struct({
	id: string,
	name: string,
	type: string,
});
